var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverCommonsModelStatus = void 0;
var ShapeDiverCommonsModelStatus;
(function (ShapeDiverCommonsModelStatus) {
  ShapeDiverCommonsModelStatus["UNKNOWN"] = "unknown";
  ShapeDiverCommonsModelStatus["NOT_UPLOADED"] = "not_uploaded";
  ShapeDiverCommonsModelStatus["UPLOADED"] = "uploaded";
  ShapeDiverCommonsModelStatus["PENDING"] = "pending";
  ShapeDiverCommonsModelStatus["CONFIRMED"] = "confirmed";
  ShapeDiverCommonsModelStatus["DENIED"] = "denied";
  ShapeDiverCommonsModelStatus["DELETED"] = "deleted";
})(ShapeDiverCommonsModelStatus || (exports.ShapeDiverCommonsModelStatus = ShapeDiverCommonsModelStatus = {}));
//# sourceMappingURL=SdCommonModel.js.map
export default exports;